module.exports = __webpack_public_path__ + "images/114835d4.png";